import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const CareerDetailsIndex = () => {
  const navigate = useNavigate();
  const { job_id } = useParams();
  useEffect(() => {
    navigate(`/career/${job_id}/details`, { replace: true });
  }, []);

  return <div />;
};

export default CareerDetailsIndex;
